import './SelectableLabelPill.css';

const SelectableLabelPill = ({ 
  label, 
  size = 'small', 
  selected = false, 
  onClick = () => {} 
}) => {
  if (!label) return null;

  const handleClick = () => {
    onClick(label.id);
  };

  return (
    <span
      className={`selectable-label-pill selectable-label-pill--${size} ${selected ? 'selected' : 'unselected'}`}
      style={{ 
        // backgroundColor: selected ? label.color : 'var(--placeholder)',
        backgroundColor: label.color,
        cursor: 'pointer'
      }}
      title={label.name}
      onClick={handleClick}
    >
      {label.name}
    </span>
  );
};

export default SelectableLabelPill;
